import { useEffect, useState } from "react";

import { Table, TableTitleLayout } from "@shared/ui";

import { ColumnsType } from "antd/es/table";
import styles from "./styles.module.scss";

import { Col, Space, Tag } from "antd";

import { useGetCampaignReachOuts } from "@entities/campaign-reach-out/lib/hooks/useGetCampaignReachOuts";
import { ICampaignReachoutInfluencer } from "@shared/lib/types/campaignReachoutInfluencer";
import { getPlatformIcon } from "@shared/lib/utils/getPlatformIcon";
import { Button } from "@shared/ui/Button";

export function CampaignReachoutManagement() {
  const [paegNo, setPageNo] = useState<number>(1);
  const [pageSize, setPageSize] = useState(10);

  const { campaignReachouts, isFetching } = useGetCampaignReachOuts(
    pageSize,
    paegNo
  );

  const handlePaginationChange = (page: number, size: number) => {
    setPageNo(page);
    setPageSize(size);
  };

  useEffect(() => {
    setPageNo(1);
  }, [pageSize]);

  const columns: ColumnsType<ICampaignReachoutInfluencer> = [
    {
      title: "Username",
      dataIndex: "username",
      key: "username",
      width: 150,
      render(value, record, index) {
        return (
          <Col>
            <div className={styles.name}> {record?.name}</div>
            <p style={{ padding: 0 }}>
              <Space className={styles.platformName}>
                {getPlatformIcon(record?.platform[0])}
                {record?.username}
              </Space>
            </p>
          </Col>
        );
      },
    },

    {
      title: "Brief",
      dataIndex: "brief",
      key: "brief",
      width: 500,
    },

    {
      title: "Brand Name",
      dataIndex: "brandName",
      key: "brandName",
      width: 100,
    },
    {
      title: "Campaign Month",
      dataIndex: "campaignMonth",
      key: "campaignMonth",
      width: 100,
    },

    {
      title: "Deliverables",
      dataIndex: "deliverables",
      key: "deliverables",
      width: 120,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render(value, record, index) {
        return (
          <Tag color={value === "Sent" ? "green" : undefined}>{value}</Tag>
        );
      },
      width: 80,
    },

    {
      title: "Replied",
      dataIndex: "isReplied",
      key: "isReplied",
      render(value, record, index) {
        return (
          <Tag color={value ? "green" : "orange"}>
            {value ? "Yes" : "Waiting for reply"}
          </Tag>
        );
      },
      width: 150,
    },

    {
      title: "EmailId",
      dataIndex: "emailId",
      key: "emailId",
      width: 200,
    },

    {
      title: "Sent From Email",
      dataIndex: "sentFromEmail",
      key: "sentFromEmail",
      width: 200,
    },

    {
      title: "Reply Email Link",
      dataIndex: "replyEmailLink",
      key: "replyEmailLink",
      width: 150,
      render: (_: string, record) =>
        record?.replyEmailLink ? (
          <Button
            type="link"
            style={{ padding: 0 }}
            onClick={(e) => {
              e.stopPropagation();
              window.open(record?.replyEmailLink);
            }}
          >
            Email link
          </Button>
        ) : (
          <></>
        ),
    },
  ];

  return (
    <div>
      <h1 className={styles.title}>Brands</h1>
        <Table
          dataSource={campaignReachouts?.data}
          columns={columns}
          loading={isFetching}
          title={() => <TableTitleLayout 
            totalText={`${campaignReachouts?.pagination?.totalCount || 0} Records found`}
          />}
          tableLayout="fixed"
          rowKey="_id"
          scroll={{ x: 1200 }}
          pagination={{
            current: paegNo,
            pageSize: pageSize,
            total: campaignReachouts?.pagination?.totalCount || 0,
            onChange: handlePaginationChange,
          }}
        />
    </div>
  );
}
